import React, { useState } from 'react';
import { CreditCardIcon, WalletIcon, ClockIcon, TrendingUpIcon, DownloadIcon, PlusIcon, CheckCircleIcon, AlertCircleIcon, ArrowUpRightIcon, ArrowDownRightIcon, FileTextIcon, DollarSignIcon, GaugeIcon, BanknoteIcon } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
export function PaymentsPage() {
  const {
    paymentInfo
  } = useAppContext();
  const [activeTab, setActiveTab] = useState('overview');
  const creditPercentage = Math.round(paymentInfo.usedCredit / paymentInfo.creditLimit * 100);
  const tabs = [{
    id: 'overview',
    label: 'Overview'
  }, {
    id: 'transactions',
    label: 'Transactions'
  }, {
    id: 'credit',
    label: 'Credit Management'
  }, {
    id: 'invoices',
    label: 'Invoices'
  }];
  const transactions = [{
    id: 'TXN-001',
    date: 'Nov 10, 2024',
    description: 'United Airlines - Flight UA4521',
    amount: -1850,
    status: 'completed',
    method: 'Credit'
  }, {
    id: 'TXN-002',
    date: 'Nov 09, 2024',
    description: 'Marriott Union Square - 3 nights',
    amount: -840,
    status: 'completed',
    method: 'Credit'
  }, {
    id: 'TXN-003',
    date: 'Nov 08, 2024',
    description: 'Uber Business - Airport Transfer',
    amount: -65,
    status: 'completed',
    method: 'Credit'
  }, {
    id: 'TXN-004',
    date: 'Nov 07, 2024',
    description: 'Refund - Cancelled Flight BK-7801',
    amount: 450,
    status: 'completed',
    method: 'Refund'
  }, {
    id: 'TXN-005',
    date: 'Nov 06, 2024',
    description: 'Delta Airlines - Flight DL4892',
    amount: -1200,
    status: 'pending',
    method: 'Pay-as-you-go'
  }, {
    id: 'TXN-006',
    date: 'Nov 05, 2024',
    description: 'Hilton Financial District - 2 nights',
    amount: -620,
    status: 'completed',
    method: 'Credit'
  }, {
    id: 'TXN-007',
    date: 'Nov 04, 2024',
    description: 'Travel Insurance - Annual Policy',
    amount: -350,
    status: 'completed',
    method: 'Pay-as-you-go'
  }, {
    id: 'TXN-008',
    date: 'Nov 03, 2024',
    description: 'Credit Top-up',
    amount: 50000,
    status: 'completed',
    method: 'Bank Transfer'
  }];
  const invoices = [{
    id: 'INV-2024-011',
    date: 'Nov 01, 2024',
    amount: '$24,500',
    status: 'Paid',
    dueDate: 'Nov 15, 2024'
  }, {
    id: 'INV-2024-010',
    date: 'Oct 01, 2024',
    amount: '$31,200',
    status: 'Paid',
    dueDate: 'Oct 15, 2024'
  }, {
    id: 'INV-2024-009',
    date: 'Sep 01, 2024',
    amount: '$28,750',
    status: 'Paid',
    dueDate: 'Sep 15, 2024'
  }, {
    id: 'INV-2024-008',
    date: 'Aug 01, 2024',
    amount: '$35,100',
    status: 'Paid',
    dueDate: 'Aug 15, 2024'
  }];
  return <div className="space-y-6" data-id="element-1964">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-1965">
        <div data-id="element-1966">
          <h2 className="text-2xl font-bold text-navy-900" data-id="element-1967">
            Payments & Billing
          </h2>
          <p className="text-slate-500" data-id="element-1968">
            Manage payments, credit, and invoices for your organization.
          </p>
        </div>
        <button className="flex items-center rounded-lg bg-navy-900 px-4 py-2 text-sm font-medium text-white hover:bg-navy-700 transition-colors" data-id="element-1969">
          <PlusIcon className="mr-2 h-4 w-4" data-id="element-1970" />
          Add Payment Method
        </button>
      </div>

      {/* Tabs */}
      <div className="flex space-x-1 bg-slate-100 rounded-lg p-1" data-id="element-1971">
        {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex-1 rounded-md px-4 py-2 text-sm font-medium transition-colors ${activeTab === tab.id ? 'bg-white text-navy-900 shadow-sm' : 'text-slate-600 hover:text-slate-900'}`} data-id="element-1972">
            {tab.label}
          </button>)}
      </div>

      {activeTab === 'overview' && <div className="space-y-6" data-id="element-1973">
          {/* Summary Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1974">
            <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-1975">
              <div className="flex justify-between items-start mb-4" data-id="element-1976">
                <div data-id="element-1977">
                  <p className="text-sm font-medium text-slate-500" data-id="element-1978">
                    Available Credit
                  </p>
                  <h3 className="text-2xl font-bold text-emerald-600 mt-1" data-id="element-1979">
                    ${paymentInfo.availableCredit.toLocaleString()}
                  </h3>
                </div>
                <div className="h-10 w-10 rounded-full bg-emerald-50 flex items-center justify-center" data-id="element-1980">
                  <WalletIcon className="h-5 w-5 text-emerald-600" data-id="element-1981" />
                </div>
              </div>
              <p className="text-xs text-slate-500" data-id="element-1982">
                of ${paymentInfo.creditLimit.toLocaleString()} limit
              </p>
            </div>
            <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-1983">
              <div className="flex justify-between items-start mb-4" data-id="element-1984">
                <div data-id="element-1985">
                  <p className="text-sm font-medium text-slate-500" data-id="element-1986">
                    Used Credit
                  </p>
                  <h3 className="text-2xl font-bold text-navy-900 mt-1" data-id="element-1987">
                    ${paymentInfo.usedCredit.toLocaleString()}
                  </h3>
                </div>
                <div className="h-10 w-10 rounded-full bg-navy-50 flex items-center justify-center" data-id="element-1988">
                  <CreditCardIcon className="h-5 w-5 text-navy-600" data-id="element-1989" />
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-1990">
                <div className="flex-1 h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-1991">
                  <div className={`h-full rounded-full ${creditPercentage > 80 ? 'bg-red-500' : creditPercentage > 60 ? 'bg-amber-500' : 'bg-emerald-500'}`} style={{
                width: `${creditPercentage}%`
              }} data-id="element-1992" />
                </div>
                <span className="text-xs font-bold text-slate-700" data-id="element-1993">
                  {creditPercentage}%
                </span>
              </div>
            </div>
            <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-1994">
              <div className="flex justify-between items-start mb-4" data-id="element-1995">
                <div data-id="element-1996">
                  <p className="text-sm font-medium text-slate-500" data-id="element-1997">
                    Pending Payments
                  </p>
                  <h3 className="text-2xl font-bold text-amber-600 mt-1" data-id="element-1998">
                    ${paymentInfo.pendingPayments.toLocaleString()}
                  </h3>
                </div>
                <div className="h-10 w-10 rounded-full bg-amber-50 flex items-center justify-center" data-id="element-1999">
                  <ClockIcon className="h-5 w-5 text-amber-600" data-id="element-2000" />
                </div>
              </div>
              <p className="text-xs text-slate-500" data-id="element-2001">3 transactions pending</p>
            </div>
            <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-2002">
              <div className="flex justify-between items-start mb-4" data-id="element-2003">
                <div data-id="element-2004">
                  <p className="text-sm font-medium text-slate-500" data-id="element-2005">
                    Total Spend YTD
                  </p>
                  <h3 className="text-2xl font-bold text-navy-900 mt-1" data-id="element-2006">
                    ${paymentInfo.totalSpend.toLocaleString()}
                  </h3>
                </div>
                <div className="h-10 w-10 rounded-full bg-blue-50 flex items-center justify-center" data-id="element-2007">
                  <TrendingUpIcon className="h-5 w-5 text-blue-600" data-id="element-2008" />
                </div>
              </div>
              <div className="flex items-center text-xs font-medium text-emerald-600" data-id="element-2009">
                <ArrowUpRightIcon className="mr-1 h-3 w-3" data-id="element-2010" />
                +8.2% vs last year
              </div>
            </div>
          </div>

          {/* Credit Gauge */}
          <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-2011">
            <h3 className="font-semibold text-slate-800 mb-6" data-id="element-2012">
              Credit Utilization
            </h3>
            <div className="flex items-center justify-center" data-id="element-2013">
              <div className="relative w-48 h-48" data-id="element-2014">
                <svg className="w-48 h-48 transform -rotate-90" viewBox="0 0 100 100" data-id="element-2015">
                  <circle cx="50" cy="50" r="40" fill="none" stroke="#e2e8f0" strokeWidth="8" data-id="element-2016" />
                  <circle cx="50" cy="50" r="40" fill="none" stroke={creditPercentage > 80 ? '#ef4444' : creditPercentage > 60 ? '#f59e0b' : '#10b981'} strokeWidth="8" strokeDasharray={`${creditPercentage * 2.51} 251`} strokeLinecap="round" data-id="element-2017" />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-2018">
                  <span className="text-3xl font-bold text-navy-900" data-id="element-2019">
                    {creditPercentage}%
                  </span>
                  <span className="text-xs text-slate-500" data-id="element-2020">utilized</span>
                </div>
              </div>
            </div>
            <div className="flex justify-center gap-8 mt-6" data-id="element-2021">
              <div className="text-center" data-id="element-2022">
                <p className="text-sm font-bold text-navy-900" data-id="element-2023">
                  ${(paymentInfo.usedCredit / 1000).toFixed(0)}k
                </p>
                <p className="text-xs text-slate-500" data-id="element-2024">Used</p>
              </div>
              <div className="text-center" data-id="element-2025">
                <p className="text-sm font-bold text-emerald-600" data-id="element-2026">
                  ${(paymentInfo.availableCredit / 1000).toFixed(0)}k
                </p>
                <p className="text-xs text-slate-500" data-id="element-2027">Available</p>
              </div>
              <div className="text-center" data-id="element-2028">
                <p className="text-sm font-bold text-slate-700" data-id="element-2029">
                  ${(paymentInfo.creditLimit / 1000).toFixed(0)}k
                </p>
                <p className="text-xs text-slate-500" data-id="element-2030">Limit</p>
              </div>
            </div>
          </div>

          {/* Recent Transactions */}
          <div className="rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-2031">
            <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4" data-id="element-2032">
              <h3 className="font-semibold text-slate-800" data-id="element-2033">
                Recent Transactions
              </h3>
              <button onClick={() => setActiveTab('transactions')} className="text-sm font-medium text-navy-700 hover:text-navy-900" data-id="element-2034">
                View All
              </button>
            </div>
            <div className="divide-y divide-slate-100" data-id="element-2035">
              {transactions.slice(0, 5).map(txn => <div key={txn.id} className="px-6 py-4 flex items-center justify-between hover:bg-slate-50 transition-colors" data-id="element-2036">
                  <div className="flex items-center gap-3" data-id="element-2037">
                    <div className={`h-8 w-8 rounded-full flex items-center justify-center ${txn.amount > 0 ? 'bg-emerald-50' : 'bg-slate-100'}`} data-id="element-2038">
                      {txn.amount > 0 ? <ArrowDownRightIcon className="h-4 w-4 text-emerald-600" data-id="element-2039" /> : <ArrowUpRightIcon className="h-4 w-4 text-slate-500" data-id="element-2040" />}
                    </div>
                    <div data-id="element-2041">
                      <p className="text-sm font-medium text-slate-900" data-id="element-2042">
                        {txn.description}
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-2043">
                        {txn.date} • {txn.method}
                      </p>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-2044">
                    <p className={`text-sm font-bold ${txn.amount > 0 ? 'text-emerald-600' : 'text-slate-900'}`} data-id="element-2045">
                      {txn.amount > 0 ? '+' : ''}
                      {txn.amount < 0 ? '-' : ''}$
                      {Math.abs(txn.amount).toLocaleString()}
                    </p>
                    <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full ${txn.status === 'completed' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-2046">
                      {txn.status}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>}

      {activeTab === 'transactions' && <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden" data-id="element-2047">
          <div className="border-b border-slate-200 px-6 py-4 flex items-center justify-between" data-id="element-2048">
            <h3 className="font-semibold text-slate-800" data-id="element-2049">
              Transaction History
            </h3>
            <button className="flex items-center rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50" data-id="element-2050">
              <DownloadIcon className="mr-1.5 h-3.5 w-3.5" data-id="element-2051" /> Export
            </button>
          </div>
          <div className="overflow-x-auto" data-id="element-2052">
            <table className="w-full text-left text-sm" data-id="element-2053">
              <thead className="bg-slate-50 text-slate-500" data-id="element-2054">
                <tr data-id="element-2055">
                  <th className="px-6 py-3 font-medium" data-id="element-2056">Transaction ID</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2057">Date</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2058">Description</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2059">Amount</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2060">Method</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2061">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-2062">
                {transactions.map(txn => <tr key={txn.id} className="hover:bg-slate-50" data-id="element-2063">
                    <td className="px-6 py-4 font-mono text-xs font-bold text-navy-700" data-id="element-2064">
                      {txn.id}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-2065">{txn.date}</td>
                    <td className="px-6 py-4 text-slate-900 font-medium" data-id="element-2066">
                      {txn.description}
                    </td>
                    <td className={`px-6 py-4 font-bold ${txn.amount > 0 ? 'text-emerald-600' : 'text-slate-900'}`} data-id="element-2067">
                      {txn.amount > 0 ? '+' : ''}
                      {txn.amount < 0 ? '-' : ''}$
                      {Math.abs(txn.amount).toLocaleString()}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-2068">{txn.method}</td>
                    <td className="px-6 py-4" data-id="element-2069">
                      <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${txn.status === 'completed' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-2070">
                        {txn.status}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}

      {activeTab === 'credit' && <div className="space-y-6" data-id="element-2071">
          <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-2072">
            <h3 className="font-semibold text-slate-800 mb-6" data-id="element-2073">
              Credit Model Configuration
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2074">
              <div data-id="element-2075">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2076">
                  Credit Limit per Organization
                </label>
                <div className="flex items-center gap-2" data-id="element-2077">
                  <span className="text-slate-500" data-id="element-2078">$</span>
                  <input type="number" className="w-full rounded-lg border border-slate-300 p-2.5 text-sm" defaultValue={200000} data-id="element-2079" />
                </div>
              </div>
              <div data-id="element-2080">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2081">
                  Warning Threshold
                </label>
                <div className="flex items-center gap-2" data-id="element-2082">
                  <input type="number" className="w-full rounded-lg border border-slate-300 p-2.5 text-sm" defaultValue={80} data-id="element-2083" />
                  <span className="text-slate-500" data-id="element-2084">%</span>
                </div>
              </div>
              <div data-id="element-2085">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2086">
                  Block Booking Threshold
                </label>
                <div className="flex items-center gap-2" data-id="element-2087">
                  <input type="number" className="w-full rounded-lg border border-slate-300 p-2.5 text-sm" defaultValue={100} data-id="element-2088" />
                  <span className="text-slate-500" data-id="element-2089">%</span>
                </div>
              </div>
              <div data-id="element-2090">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2091">
                  Billing Cycle
                </label>
                <select className="w-full rounded-lg border border-slate-300 p-2.5 text-sm" data-id="element-2092">
                  <option data-id="element-2093">Monthly</option>
                  <option data-id="element-2094">Bi-weekly</option>
                  <option data-id="element-2095">Weekly</option>
                </select>
              </div>
            </div>
            <div className="mt-6 flex justify-end" data-id="element-2096">
              <button className="rounded-lg bg-navy-900 px-6 py-2 text-sm font-medium text-white hover:bg-navy-700" data-id="element-2097">
                Save Settings
              </button>
            </div>
          </div>

          {/* Pay-as-you-go Section */}
          <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-2098">
            <h3 className="font-semibold text-slate-800 mb-4" data-id="element-2099">
              Pay-as-you-go Settings
            </h3>
            <p className="text-sm text-slate-600 mb-4" data-id="element-2100">
              When enabled, payment is required before ticket issuance for
              bookings that exceed credit limits.
            </p>
            <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2101">
              <div data-id="element-2102">
                <h4 className="font-medium text-slate-900" data-id="element-2103">
                  Require Payment Before Ticketing
                </h4>
                <p className="text-xs text-slate-500" data-id="element-2104">
                  Travelers must complete payment before tickets are issued
                </p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer" data-id="element-2105">
                <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2106" />
                <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-navy-700" data-id="element-2107" />
              </label>
            </div>
          </div>
        </div>}

      {activeTab === 'invoices' && <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-hidden" data-id="element-2108">
          <div className="border-b border-slate-200 px-6 py-4 flex items-center justify-between" data-id="element-2109">
            <h3 className="font-semibold text-slate-800" data-id="element-2110">Invoice History</h3>
            <button className="flex items-center rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50" data-id="element-2111">
              <PlusIcon className="mr-1.5 h-3.5 w-3.5" data-id="element-2112" /> Generate Invoice
            </button>
          </div>
          <div className="overflow-x-auto" data-id="element-2113">
            <table className="w-full text-left text-sm" data-id="element-2114">
              <thead className="bg-slate-50 text-slate-500" data-id="element-2115">
                <tr data-id="element-2116">
                  <th className="px-6 py-3 font-medium" data-id="element-2117">Invoice ID</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2118">Date</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2119">Amount</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2120">Due Date</th>
                  <th className="px-6 py-3 font-medium" data-id="element-2121">Status</th>
                  <th className="px-6 py-3 font-medium text-right" data-id="element-2122">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-2123">
                {invoices.map(inv => <tr key={inv.id} className="hover:bg-slate-50" data-id="element-2124">
                    <td className="px-6 py-4 font-mono text-xs font-bold text-navy-700" data-id="element-2125">
                      {inv.id}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-2126">{inv.date}</td>
                    <td className="px-6 py-4 font-bold text-slate-900" data-id="element-2127">
                      {inv.amount}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-2128">{inv.dueDate}</td>
                    <td className="px-6 py-4" data-id="element-2129">
                      <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700" data-id="element-2130">
                        {inv.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-2131">
                      <button className="text-navy-700 hover:text-navy-900" data-id="element-2132">
                        <DownloadIcon className="h-4 w-4 inline" data-id="element-2133" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>}
    </div>;
}